import script from "./deferItems.vue?vue&type=script&setup=true&lang=js"
export * from "./deferItems.vue?vue&type=script&setup=true&lang=js"

import "./deferItems.vue?vue&type=style&index=0&id=056a910c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056a910c"]])

export default __exports__